// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".age-certification-filter .filter-section[data-v-86d76040]{padding:0 5px}.age-certification-filter .filter-section__options[data-v-86d76040]{display:flex;flex-flow:wrap;margin-top:5px}", ""]);
// Exports
module.exports = exports;
